

































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { State, Action, namespace } from 'vuex-class'
import { PunchData } from '@/model/plan/shareCard'
import QRCode from 'qrcode'
import MyDayPlan from '../../../../model/plan/myDayPlan'
import genv from 'ykd-base/env'
import { getSharePunchData } from '@/api/plan/shareCard'
import Spinner from '@/components/Spinner.vue'
import html2canvas from 'html2canvas'

const ModuleStudyPlan = namespace('app-ice/studyPlan')

@Component({
  components: {
    Spinner,
  },
})
export default class PunchCard extends Vue {
  @ModuleStudyPlan.Action('fetchPuchData')
  fetchPuchData!: Function
  @ModuleStudyPlan.Action('fetchMyDayPlan')
  fetchMyDayPlan!: Function
  @ModuleStudyPlan.State('myDayPlan')
  private myDayPlan!: MyDayPlan
  @ModuleStudyPlan.State('punchData')
  private punchData!: PunchData
  // @Prop({ type: String })
  private cardType?: string
  private qrCodeImgUrl: string = ''
  private localCardType: string = ''
  private punchCardData: any = ''
  exportUrl: string = ''
  private myDayPlanId: string = ''
  private unit: string = '分钟' // 1:分钟 2:小时

  async mounted() {
    await this.openComponent2()

    setTimeout(() => {
      this.save()
    }, 1000)
  }

  transLateMillisecond(ms: number) {
    if (ms) {
      if (ms / 3600000 >= 1) {
        let hours = ms / 3600000
        this.unit = '小时'
        return hours.toFixed(1)
      } else {
        let minutes = parseInt((ms / 60000).toString())
        this.unit = '分钟'
        return minutes
      }
    }
    return `0分钟`
  }

  save() {
    let doc: any = document
    // document.domain = 'http://dev.youkeda.com:1024/'
    html2canvas(doc.getElementById('square'), {
      scale: 3,
      useCORS: true,
    }).then((canvas: any) => {
      this.exportUrl = canvas.toDataURL()
    })
  }

  rmSchema(url: string) {
    if (url) {
      url = url.replace(/http(s?):/, '')
    }
    return url
  }

  @Watch('cardType', { immediate: true })
  @Watch('$route', { immediate: true })
  onChange() {
    if (this.$route.query.type && typeof this.$route.query.type === 'string') {
      this.localCardType = this.$route.query.type
    }
    if (this.cardType) {
      this.localCardType = this.cardType
    }

    this.localCardType = this.localCardType || 'punch'
  }

  isMobile() {
    const mobilePlatform = [
      'Android',
      'iPhone',
      'SymbianOS',
      'Windows Phone',
      'iPad',
      'iPod',
    ]
    let isMobile = false
    mobilePlatform.map((platform) => {
      if (window.navigator.userAgent.indexOf(platform) !== -1) {
        isMobile = true
      }
    })
    return isMobile
  }

  //保存图片
  saveImg() {
    let myCanvas = document.getElementsByTagName('canvas')
    this.qrCodeImgUrl = myCanvas[0].toDataURL('image/png')
  }
  //打开二维码弹窗
  async openComponent2() {
    if (this.isMobile()) {
      const { type, myDayPlanId } = this.$route.query
      this.myDayPlanId = myDayPlanId as string
      this.cardType = <string>type
      if (myDayPlanId) {
        const data: PunchData = await getSharePunchData(
          myDayPlanId as string,
          true
        )
        this.punchCardData = data
      }
    } else {
      if (!this.myDayPlan) {
        await this.fetchMyDayPlan()
      }
      this.myDayPlanId = this.myDayPlan.id as string
      await this.fetchPuchData(this.myDayPlan.id)
      this.punchCardData = this.punchData
    }
    // let href = `http://dev.youkeda.com:1024/personal/studyplan/punch_card`
    const domain =
      genv === 'development'
        ? process.env[`VUE_APP_HOST_development_ham`]
        : process.env[`VUE_APP_HOST_production_ham`]
    let href = `${domain}/personal/studyplan/punch_card?myDayPlanId=${
      this.myDayPlanId
    }`
    // let href = `http://192.168.1.187:1024/personal/studyplan/punch_card?myDayPlanId=${this.myDayPlanId}`
    var canvas = document.getElementById('canvasPunchCard')
    QRCode.toCanvas(canvas, href, { width: 72 })

    // QRCode.toCanvas(canvas, href, function(error) {
    //   if (error) {
    //     console.error(error)
    //   } else {
    //     console.log('success!')
    //     this.saveImg()
    //   }
    // })
    // this.saveImg()
  }
}
